'use strict';

exports.__esModule = true;
exports.getProfilesIds = exports.loaderFromQueryOptions = exports.loadProfileReviews = exports.loadProfilesReviews = exports.QUERY_SPECIALISTS_PROFILE_TYPE = exports.QUERY_PRACTICES_PROFILE_TYPE = exports.DEFAULT_REVIEWS_OFFSET = exports.DEFAULT_REVIEWS_LIMIT = exports.tabsElements = exports.tabsArray = exports.PRACTICE_REVIEWS_TAB = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _tabsElements;

var _aboutPracticesTab = require('../components/about-practices-tab');

var _aboutPracticesTab2 = _interopRequireDefault(_aboutPracticesTab);

var _widgetActions = require('../actions/widget-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PRACTICE_REVIEWS_TAB = exports.PRACTICE_REVIEWS_TAB = 'WF_PRACTICE_GROUP_REVIEWS_TAB';
var tabsArray = exports.tabsArray = [PRACTICE_REVIEWS_TAB];

var tabsElements = exports.tabsElements = (_tabsElements = {}, _tabsElements[PRACTICE_REVIEWS_TAB] = {
    elem: _aboutPracticesTab2.default,
    id: 'wfGroupReviewsWidget.aboutPractices'
}, _tabsElements);

var DEFAULT_REVIEWS_LIMIT = exports.DEFAULT_REVIEWS_LIMIT = 6;
var DEFAULT_REVIEWS_OFFSET = exports.DEFAULT_REVIEWS_OFFSET = 0;

var QUERY_PRACTICES_PROFILE_TYPE = exports.QUERY_PRACTICES_PROFILE_TYPE = 'practices';
var QUERY_SPECIALISTS_PROFILE_TYPE = exports.QUERY_SPECIALISTS_PROFILE_TYPE = 'specialists';

var loadProfilesReviews = exports.loadProfilesReviews = function loadProfilesReviews(profilesIds, profileType, limit, offset, minReviewRating, dispatch, xhrConfig) {
    return profilesIds.length ? _promise2.default.all([dispatch(_widgetActions.widgetActions.changeOffset(offset)), _widgetActions.widgetActions.loadReviewsStatForAllPractices(profilesIds, xhrConfig)(dispatch), _widgetActions.widgetActions.loadReviewsForAllPractices(profilesIds, limit, offset, minReviewRating, xhrConfig)(dispatch)]).catch(function (error) {
        console.log(error);
    }) : _promise2.default.resolve();
};

var loadProfileReviews = exports.loadProfileReviews = function loadProfileReviews(profileId, profileType, limit, offset, minReviewRating, dispatch, xhrConfig) {
    return _promise2.default.all([dispatch(_widgetActions.widgetActions.changeOffset(offset)), _widgetActions.widgetActions.loadReviewsStatForOne(profileId, profileType, xhrConfig)(dispatch), _widgetActions.widgetActions.loadReviewsForOne(profileId, profileType, limit, offset, minReviewRating, xhrConfig)(dispatch)]).catch(function (error) {
        console.log(error);
    });
};

var loaderFromQueryOptions = exports.loaderFromQueryOptions = function loaderFromQueryOptions(profilesIds, activeTab, limit, offset, minReviewRating, dispatch, xhrConfig) {
    switch (activeTab) {
        case PRACTICE_REVIEWS_TAB:
        default:
            return loadProfilesReviews(profilesIds, QUERY_PRACTICES_PROFILE_TYPE, limit, offset, minReviewRating, dispatch, xhrConfig);
    }
};

var getProfilesIds = exports.getProfilesIds = function getProfilesIds(items) {
    return items.filter(function (item) {
        return Boolean(item.id);
    }).map(function (item) {
        return item.id;
    });
};